<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row v-if="badrequest === false">
      <v-col cols="2" style="align-self: center">
        <v-img
          src="@/assets/UM6PLOGO.png"
          contain
          max-height="25"
          max-width="150"
          class="d-flex justify-start"
        ></v-img>
      </v-col>
      <v-col cols="8"> </v-col>
      <v-col cols="2" class="d-flex justify-end" style="display: grid !important">
        <v-btn-toggle class="ml-auto">
          <v-btn @click="ChangerLangue('fr')">
            <v-img src="@/assets/france-flag-icon.svg" contain max-height="25">
            </v-img>
          </v-btn>
          <v-btn @click="ChangerLangue('en')">
            <v-img
              src="@/assets/english-flag-icon.svg"
              contain
              max-height="25"
            ></v-img>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row v-if="badrequest === false">
      <v-col cols="12">
        <v-card
          elevation="1"
          v-for="(inscription, index) in $storeSousMenu.Data.ListeInscriptions"
          :key="index"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3" class="col_header">
                {{ $storeSousMenu.Label.StatutInscription }} :
              </v-col>
              <v-col cols="12" md="9" class="col_content">
                {{
                  $storeSousMenu.ItemLang == "lang01"
                    ? inscription.statut.lang01
                    : inscription.statut.lang00
                }}
              </v-col> 
            </v-row>
            <v-row v-if="inscription.detailCandidature">
              <v-col cols="12" md="3" class="col_header">
                {{ $storeSousMenu.Label.DetailCandidature }} :
              </v-col>
              <v-col cols="12" md="9" class="col_content">
                <div v-html="inscription.detailCandidature"></div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="col_header">
                {{ $storeSousMenu.Label.DateModification }} :
              </v-col>
              <v-col cols="12" md="9" class="col_content">
                {{ inscription.modifieLe }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="col_header">
                {{ $storeSousMenu.Label.ListeProgrammes }} :
              </v-col>
              <v-col cols="12" md="9" class="col_content">
                <v-row
                  v-for="(programme, index) in inscription.programmes"
                  :key="index"
                >
                  <v-col cols="12">
                    <div>
                      {{ $storeSousMenu.Label.Choix }} {{ index + 1 }} :
                      {{ programme.paramProgrammeUM6PLabel }}
                    </div>
                    <div v-if="programme.resultat">
                      {{ $storeSousMenu.Label.Statut }} :
                      <span
                        :style="'color:' + ColorClass(programme.resultat.id)"
                      >
                        {{
                          $storeSousMenu.ItemLang == "lang01"
                            ? programme.resultat.lang01
                            : programme.resultat.lang00
                        }}
                      </span>
                    </div>
                    <div v-if ="programme.resultat && programme.details != null">
                      {{ $storeSousMenu.Label.Details }} :
                      <span v-html="programme.details"></span>
                    </div>
                    <div
                      v-if="programme.resultat && programme.modifieLe != null"
                    >
                      {{ $storeSousMenu.Label.DerniereMiseAJour }} :
                      <span>
                        {{ formatDate(programme.modifieLe) }}
                      </span>
                    </div>
                    <span v-if="programme.specialiteRetenue">Spécialité retenue: {{ programme.specialiteRetenue }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      $storeSousMenu: this.$storeSousMenu,
      loader: false,
      badrequest: true,
    };
  },
  methods: {
    ColorClass(statut) {
      let color = "#000000";

      if (statut === this.$storeSousMenu.Data.DataId.ProgrammeEnCours) {
        color = "#f39c12";
      } else if (
        statut === this.$storeSousMenu.Data.DataId.ProgrammeAdmissible
      ) {
        color = "#16a085";
      } else if (statut === this.$storeSousMenu.Data.DataId.ProgrammeNonAdmis) {
        color = "#c0392b";
      }

      return color;
    },
    ChangerLangue(langue) {
      // Mettre à jour la langue des rules
      this.$rules.lang = langue;
      if (langue === "en") {
        this.$storeSousMenu.Label = this.$storeSousMenu.LabelEn;
        this.$storeSousMenu.ItemLang = "lang01";
      } else {
        this.$storeSousMenu.Label = this.$storeSousMenu.LabelFr;
        this.$storeSousMenu.ItemLang = "lang00";
      }
    },
    formatDate(date) {
      if (!date) return null;

      let [year, month, dayTime] = date.split("-");
      let day = dayTime.split("T")[0];
      return `${day}/${month}/${year}`;
    },
  },
  mounted() {
    let token = this.$route.query.t;
    if (token) {
      token = token.replace(/\s/g, "+");
    }

    this.badrequest = true;
    this.loader = true;
    let self = this;

    Promise.all([
      this.$storeSousMenu
        .GetInformations(token)
        .then((reponse) => {
          if (reponse && reponse.status === 200) {
            this.$storeSousMenu.AffecterDto(reponse.data);
            this.badrequest = false;
          }
        })
        .catch((error) => {
          console.log(error);
        }),
    ])
      .then(function () {
        self.loader = false;
        if(self.badrequest){
          self.$router.push("/NonConnecte");
        }
      })
      .catch((error) => {
        console.log(error);
        self.loader = false;
      });
  },
};
</script>

<style scoped src="@/assets/css/SousMenuUm6p.css"></style>
